import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import "./tokens.css";
import "./styles.css";
import "./editorial-ui.css";
import "./readium-reader-subset.css";

const root = document.getElementById("root");

if (!root) {
  throw new Error("Loomua root element is missing");
}

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>
);
